import {
  fetchGetVehicles,
  fetchPostVehicles,
  fetchPutVehiclesId,
} from "./actions";
import {
  getVehiclesTransportFacilityModals,
  getVehiclesTransportFacilityModalsById,
  getIsVehiclesLoaded,
  getIsVehiclesLoadingError,
  getVehiclesByCurrentSemanticMap,
  getVehicles,
  getVehiclesDict,
} from "./selectors";
import VehiclesSlice from "./reducers";

// actions
export const { addNewVehicle, updateVehicle, resetVehicles, updateVehicles } =
  VehiclesSlice.actions;

// async actions
export { fetchGetVehicles, fetchPostVehicles, fetchPutVehiclesId };

// selectors
export {
  getVehiclesTransportFacilityModals,
  getVehiclesTransportFacilityModalsById,
  getIsVehiclesLoaded,
  getIsVehiclesLoadingError,
  getVehiclesByCurrentSemanticMap,
  getVehicles,
  getVehiclesDict,
};

// reducer
export default VehiclesSlice.reducer;
